var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formStore.questions.length
    ? _c("fragment", [
        _c(
          "div",
          { staticClass: "e-form-row", attrs: { id: "_form_field_question" } },
          [
            _c("div", { staticClass: "e-input-label m-full" }, [
              _c("span", { staticClass: "e-input-mark m-required" }, [
                _vm._v("必須")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "e-input-label" }, [_vm._v("ご質問")])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "e-form-row m-block m-no-margin" }, [
          _c(
            "dl",
            { staticClass: "e-question" },
            _vm._l(_vm.formStore.questions, function(question) {
              return _c("question-row", {
                key: question.ordered,
                attrs: { question: question }
              })
            }),
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }